import { all } from 'redux-saga/effects'
import auth from './auth/sagas'
import menu from './menu/sagas'
import settings from './settings/sagas'

export default function* rootSaga() {
  yield all(
    [
      auth(),
    // user(), 
    menu(), 
    settings()
  ])
}
